/** Fabricated customer threads as they stream in under the type's rows, until the saved rows take their place. */

import { Loader2 } from 'lucide-react';
import type { FabricatedPreview } from '@/services/ai-function.service';
import { KindBadge } from '../../kind-badge';
import { ScenarioRowTitle } from '../scenario-rows';

export const FabricatedPreviewRows = ({ previews }: { previews: FabricatedPreview[] }) => (
	<div className='flex flex-col divide-y divide-gray-500 border-t border-gray-500' aria-live='polite'>
		{previews.map((preview, index) => (
			<div key={index} className='flex items-center gap-2 py-2.5 pr-2 pl-3 text-gray-800'>
				<ScenarioRowTitle title={preview.description} subtitle={preview.query[0]?.text} className='flex-1' />
				<KindBadge kind='fabricated' />
			</div>
		))}
		<p className='flex items-center gap-2 px-3 py-2.5 text-xs leading-4 text-gray-800'>
			<Loader2 className='size-3.5 shrink-0 animate-spin' />
			Writing {previews.length ? 'the next' : 'a'} customer thread…
		</p>
	</div>
);
